export const setOptionsForInviteToTeammateModal = ({
  mentionedNewEmail = '',
  isOpen = false,
  isDirectInvite = false,
  isEmailMandatory = false,
  modalHeaderTitle = '',
  isRedirectTo = true,
}) => ({
  type: 'SET_OPTIONS_FOR_INVITE_TO_TEAMMATE_MODAL',
  payload: {
    mentionedNewEmail,
    isOpen,
    isDirectInvite,
    isEmailMandatory,
    modalHeaderTitle,
    isRedirectTo,
  },
});

export const resetOptionsForInviteToTeammateModal = () => ({ type: 'RESET_OPTIONS_FOR_INVITE_TO_TEAMMATE_MODAL' });
